module.exports = __webpack_public_path__ + "img/PartyQuest_Logo.850d78cd.png";